import { post } from '@/util/auth'

import { API_PATH_CREDIT_REQUEST_QN_NN } from './apiRoutes'

type QnNnPayload = {
  qn: string
  nn: string
  creditRequestId: number
}

const creaditRequestResources = {
  postQnNn: (payload: QnNnPayload) =>
    post<QnNnPayload>(
      API_PATH_CREDIT_REQUEST_QN_NN.replace(':creditRequestId', String(payload.creditRequestId)),
      { nn: payload.nn, qn: payload.qn }
    ),
}

export default creaditRequestResources
